/* BEBELUX newsletter popup. Uses the existing first-party newsletter Hub. */
(function () {
  'use strict';
  if (!window.customElements || customElements.get('bb-newsletter-glass')) return;

  var STORAGE_KEY = 'bb:newsletter-glass';
  var TEASER_DISMISSED_KEY = 'bb:newsletter:teaser-dismissed';
  var teaserDismissedInMemory = false;
  var LOCKOUT_MS = 30 * 24 * 60 * 60 * 1000;
  var BOTTOM_BARS = '.product-sticky-form,.mobile-dock,[data-sticky-cart],[class*="sticky-atc"],.bb-sticky-atc';
  var WEBMAIL = {
    'gmail.com': 'https://mail.google.com/mail/u/0/', 'googlemail.com': 'https://mail.google.com/mail/u/0/',
    'outlook.com': 'https://outlook.live.com/mail/', 'hotmail.com': 'https://outlook.live.com/mail/',
    'hotmail.de': 'https://outlook.live.com/mail/', 'live.com': 'https://outlook.live.com/mail/',
    'live.de': 'https://outlook.live.com/mail/', 'yahoo.com': 'https://mail.yahoo.com/',
    'yahoo.de': 'https://mail.yahoo.com/', 'gmx.de': 'https://www.gmx.net/',
    'gmx.net': 'https://www.gmx.net/', 'gmx.com': 'https://www.gmx.com/',
    'web.de': 'https://web.de/', 't-online.de': 'https://email.t-online.de/',
    'icloud.com': 'https://www.icloud.com/mail/', 'me.com': 'https://www.icloud.com/mail/',
    'mac.com': 'https://www.icloud.com/mail/'
  };

  function readState() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {}; } catch (error) { return {}; }
  }
  function writeState(patch) {
    try {
      var state = readState();
      Object.keys(patch).forEach(function (key) { state[key] = patch[key]; });
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (error) {}
  }
  function teaserDismissed() {
    if (teaserDismissedInMemory) return true;
    try { return window.sessionStorage.getItem(TEASER_DISMISSED_KEY) === '1'; } catch (error) { return false; }
  }
  function focusableInside(root) {
    return Array.prototype.slice.call(root.querySelectorAll('button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),a[href],[tabindex]:not([tabindex="-1"])')).filter(function (element) {
      return element.getClientRects().length > 0;
    });
  }

  class BbNewsletterGlass extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;
      this.overlay = this.querySelector('.bbng-overlay');
      this.card = this.querySelector('.bbng-card');
      this.teaser = this.querySelector('.bbng-teaser');
      this.form = this.querySelector('.bbng-form');
      this.input = this.querySelector('.bbng-input');
      this.button = this.querySelector('.bbng-btn');
      this.errorEl = this.querySelector('.bbng-error');
      this.surface = this.dataset.surface || 'excluded';
      this.subscribed = this.dataset.subscribed === 'true';
      this.testMode = this.dataset.test === 'true';
      this._returnFocus = null;
      if (!this.overlay || !this.card) return;
      this._bind();
      this._bindHub();
      this._bindExperience();
      this._positionTeaser();
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this._onKey);
      window.removeEventListener('resize', this._reposition);
      window.removeEventListener('scroll', this._reposition);
      if (window.visualViewport) window.visualViewport.removeEventListener('resize', this._reposition);
      if (this._unsubscribe) this._unsubscribe();
      if (this._hubReadyListener) document.removeEventListener('bb:newsletter-hub-ready', this._hubReadyListener);
      this._signal(false);
    }

    _bind() {
      var self = this;
      this.querySelectorAll('[data-bbng-close]').forEach(function (element) {
        element.addEventListener('click', function (event) { event.preventDefault(); self.close(); });
      });
      this.overlay.addEventListener('click', function (event) { if (event.target === self.overlay) self.close(); });
      var openButton = this.querySelector('[data-bbng-open]');
      if (openButton) openButton.addEventListener('click', function () { self.open(true); });
      var teaserClose = this.querySelector('[data-bbng-teaser-close]');
      if (teaserClose) teaserClose.addEventListener('click', function () { self._dismissTeaser(); });
      var inbox = this.querySelector('[data-bbng-inbox]');
      if (inbox) inbox.addEventListener('click', function () { self._openInbox(); });
      this._onKey = function (event) {
        if (!self.overlay.classList.contains('is-open')) return;
        if (event.key === 'Escape') { event.preventDefault(); self.close(); return; }
        if (event.key !== 'Tab') return;
        var items = focusableInside(self.overlay);
        if (!items.length) return;
        var first = items[0], last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      };
      document.addEventListener('keydown', this._onKey);
      var raf = 0;
      this._reposition = function () {
        if (raf) return;
        raf = requestAnimationFrame(function () { raf = 0; self._positionTeaser(); });
      };
      window.addEventListener('resize', this._reposition);
      window.addEventListener('scroll', this._reposition, { passive: true });
      if (window.visualViewport) window.visualViewport.addEventListener('resize', this._reposition);
    }

    _bindExperience() {
      var self = this;
      function connect() {
        if (!window.bbExperience) { window.setTimeout(connect, 50); return; }
        self._unsubscribe = window.bbExperience.onChange(function (snapshot) { self._evaluate(snapshot); });
        self._evaluate(window.bbExperience.snapshot());
        if (self.testMode && self.surface === 'eligible') window.setTimeout(function () { self.open(false); }, 400);
      }
      connect();
    }

    _evaluate(snapshot) {
      var saved = readState();
      var lockedOut = !!(saved.dismissedAt && Date.now() - saved.dismissedAt < LOCKOUT_MS);
      var complete = this.subscribed || saved.requestAccepted;
      if (complete || this.surface === 'excluded') { this._hideTeaser(); return; }
      if (this.surface === 'cart') {
        if (saved.dismissedAt) this._showTeaser();
        return;
      }
      if (lockedOut) { this._showTeaser(); return; }
      var candidate = Object.assign({}, snapshot, { subscribed: complete, lockedOut: lockedOut });
      if (window.bbExperience.canAutoOpen(candidate)) {
        window.bbExperience.markAutoOpened();
        this.open(false);
      }
    }

    open(manual) {
      if (this.surface !== 'eligible' && !(manual && this.surface === 'cart')) return;
      if (this.subscribed || readState().requestAccepted) return;
      this._returnFocus = document.activeElement;
      this._hideTeaser();
      this.overlay.classList.add('is-open');
      this.overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      this._signal(true);
      var self = this;
      window.setTimeout(function () {
        var target = self.input && !self.input.disabled ? self.input : self.querySelector('[data-bbng-close]');
        if (target) try { target.focus({ preventScroll: true }); } catch (error) { target.focus(); }
      }, 50);
    }

    close() {
      var wasOpen = this.overlay.classList.contains('is-open');
      this.overlay.classList.remove('is-open');
      this.overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      this._signal(false);
      if (!this.card.classList.contains('is-success')) {
        if (!this.testMode) writeState({ dismissedAt: Date.now() });
        this._showTeaser();
      } else this._hideTeaser();
      if (wasOpen && this._returnFocus && this._returnFocus.focus) {
        try { this._returnFocus.focus({ preventScroll: true }); } catch (error) { this._returnFocus.focus(); }
      }
      this._returnFocus = null;
    }

    _signal(open) {
      document.dispatchEvent(new CustomEvent('bb:newsletter-ui', { detail: { open: !!open } }));
      if (window.bbExperience) window.bbExperience.setLayer('newsletter', !!open);
    }
    _showTeaser() {
      if (!this.teaser || this.subscribed || readState().requestAccepted || teaserDismissed()) return;
      this.teaser.classList.add('is-visible');
      this._positionTeaser();
    }
    _dismissTeaser() {
      teaserDismissedInMemory = true;
      try { window.sessionStorage.setItem(TEASER_DISMISSED_KEY, '1'); } catch (error) {}
      this._hideTeaser();
    }
    _hideTeaser() { if (this.teaser) this.teaser.classList.remove('is-visible'); }
    _positionTeaser() {
      if (!this.teaser || !this.teaser.classList.contains('is-visible')) return;
      var viewportHeight = window.visualViewport ? window.visualViewport.height : document.documentElement.clientHeight;
      var lift = 0;
      document.querySelectorAll(BOTTOM_BARS).forEach(function (element) {
        var style = getComputedStyle(element); var rect = element.getBoundingClientRect();
        if (style.display !== 'none' && style.visibility !== 'hidden' && rect.height > 8 && rect.top < viewportHeight && rect.bottom > viewportHeight * 0.55) {
          lift = Math.max(lift, viewportHeight - rect.top + 12);
        }
      });
      this.teaser.style.setProperty('--bbng-teaser-bottom', Math.max(16, lift) + 'px');
    }

    _bindHub() {
      var self = this;
      if (!this.form || !window.BbNewsletterHub) {
        if (this.button) this.button.disabled = true;
        if (!this._hubReadyListener) {
          this._hubReadyListener = function () { self._hubReadyListener = null; if (self.isConnected) self._bindHub(); };
          document.addEventListener('bb:newsletter-hub-ready', this._hubReadyListener, { once: true });
        }
        return;
      }
      window.BbNewsletterHub.mount(this.form, {
        errorElement: this.errorEl,
        onBusy: function (busy) { if (self.button) self.button.classList.toggle('is-loading', busy); },
        onAccepted: function (email) {
          if (!self.testMode) writeState({ requestAccepted: true });
          self._hideTeaser(); self._showInboxButton(email); self.card.classList.add('is-success');
        }
      });
    }
    _openInbox() {
      var domain = ((this.input && this.input.value || '').trim().toLowerCase().split('@')[1] || '');
      if (WEBMAIL[domain]) window.open(WEBMAIL[domain], '_blank', 'noopener');
    }
    _showInboxButton(email) {
      var button = this.querySelector('[data-bbng-inbox]');
      if (!button) return;
      var domain = ((email || '').split('@')[1] || '').toLowerCase();
      button.style.display = WEBMAIL[domain] ? '' : 'none';
    }
  }

  customElements.define('bb-newsletter-glass', BbNewsletterGlass);
})();
